<template>
	<div class="shuping" :class="{ active: active }">
		<p>{{ txt }}</p>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
		name: 'shuPing',
		mounted() {
			var reset = () => {
				var $win = window
				if ($win.orientation == 90 || $win.orientation == -90) {
					//横屏
					this.active = true
				} else {
					//竖屏
					this.active = false
				}
			}
			var bindResize = () => {
				window.addEventListener(
					'onorientationchange' in window ? 'orientationchange' : 'resize',
					function () {
						setTimeout(reset, 300)
					},
					false
				)
			}
			reset()
			bindResize()
		},
		data() {
			return {
				active: false
			}
		},
		components: {},
		computed: {
			...mapState(['curLan']),
			txt() {
				let lan2tip = {
					tc: '推薦使用豎屏進行瀏覽 ',
					ja: '縦位置で視聴をおすすめです ',
					ko: `핸드폰 화면 세로 회전하여 사용하시면,
                더 좋은 시각 효과를 체험할 수 있습니다. `,
					en: 'Please rotate your device to portait mode for better display '
				}

				return lan2tip[this.curLan]
			}
		}
	}
</script>
<style lang="less">
	.shuping {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 10001;
		display: none;
		background-color: rgba(0, 0, 0, 0.7);
		padding: 0 20px;
		display: none;
		justify-content: center;
		align-items: center;
        box-sizing: border-box;

		p {
			font-size: 30px;
			color: #fff;
		}
		&.active {
			display: flex;
		}
	}
</style>
